import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DataService } from 'app/services/data-service';

var fireRefreshEventOnWindow = function () {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent('resize', true, false);
    window.dispatchEvent(evt);
};

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent implements OnInit {

    exibeSideBar: boolean;
    constructor(
        private elementRef: ElementRef,
        public router: Router,
        private route: ActivatedRoute,
        private dataService: DataService
        ) { 
            this.dataService.obterStatusSideBarIsOpen()
                .subscribe(valor => {
                    this.exibeSideBar = valor;
            });
        }

    ngOnInit() {
        //sidebar toggle event listner
        let elSidebarToggle = this.elementRef.nativeElement.querySelector('#sidebarToggle')
        if(elSidebarToggle){
            elSidebarToggle.addEventListener('click', this.onClick.bind(this));
        }            
        //customizer events
        let elCompactMenu = this.elementRef.nativeElement.querySelector('#cz-compact-menu');
        if(elCompactMenu){
            elCompactMenu.addEventListener('click', this.onClick.bind(this));
        }
        let elSidebarWidth = this.elementRef.nativeElement.querySelector('#cz-sidebar-width');
        if(elSidebarWidth){
            elSidebarWidth.addEventListener('click', this.onClick.bind(this));
        }            
            
    }
    onClick(event) {
        //initialize window resizer event on sidebar toggle click event
        setTimeout(() => { fireRefreshEventOnWindow() }, 300);
    }

    
objetoAchado = []
    reciverObjeto(obj){
        console.log('full layout', obj)
        this.objetoAchado = obj
    }

}


// WEBPACK FOOTER //
// ./src/app/layouts/full/full-layout.component.ts